var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitterWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "52px",
    height: "42px",
    viewBox: "0 0 52 42",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icons8-twitter") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons8-twitter",
    transform: "translate(0.941406, 0.617188)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.1210938,4.820312 C48.2734378,5.640625 46.2929688,6.191406 44.2109378,6.441406 C46.3359378,5.167968 47.9687498,3.152343 48.7343748,0.753906 C46.7499998,1.929687 44.5429688,2.785156 42.2031248,3.246093 C40.3281248,1.246093 37.6562498,8.8817842e-16 34.6992188,8.8817842e-16 C29.0195318,8.8817842e-16 24.4140628,4.601562 24.4140628,10.28125 C24.4140628,11.085937 24.5078128,11.871093 24.6835938,12.625 C16.1367188,12.195312 8.5624998,8.101562 3.4882818,1.878906 C2.6015628,3.402343 2.0976568,5.167968 2.0976568,7.050781 C2.0976568,10.617187 3.9101568,13.765625 6.6718748,15.613281 C4.9843748,15.558593 3.3984378,15.09375 2.0117188,14.324218 C2.0117188,14.367187 2.0117188,14.410156 2.0117188,14.453125 C2.0117188,19.4375 5.5585938,23.589843 10.2578128,24.539062 C9.3984378,24.773437 8.4882818,24.898437 7.5507818,24.898437 C6.8867188,24.898437 6.2421878,24.835937 5.6132818,24.710937 C6.9257818,28.792968 10.7226568,31.773437 15.2187498,31.855468 C11.7031248,34.613281 7.2695318,36.253906 2.4492188,36.253906 C1.6171878,36.253906 0.8007818,36.207031 5.82867088e-16,36.109375 C4.5468748,39.03125 9.9531248,40.730468 15.7617188,40.730468 C34.6757818,40.730468 45.0195318,25.0625 45.0195318,11.476562 C45.0195318,11.03125 45.0078128,10.582031 44.9921878,10.144531 C47,8.695312 48.7421878,6.882812 50.1210938,4.820312 Z",
    id: "Path"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterWhite);
export default __webpack_public_path__ + "static/media/twitter-white.e7b221f5e00aa34e0ce97bb50667e06b.svg";
export { ForwardRef as ReactComponent };